/* ==========================================================================
   ergovo-overlay.js
   Gemeinsame Steuerung fuer alle Overlays: Menue-Drawer, Suchmodal und
   Warenkorb-Drawer.

   Behebt drei Fehler, die sich beim Durchklicken des mobilen Menues gezeigt
   haben:

   1) Verschobener Drawer beim Oeffnen.
      Die Wischgeste bewegt das Panel ueber ein Inline-transform. Beim
      Schliessen per Wisch wurde dieser Inline-Wert nicht zurueckgesetzt. Er
      ueberschreibt danach die CSS-Regel fuer den offenen Zustand, sodass der
      Drawer beim naechsten Oeffnen seitlich versetzt stehen blieb.

   2) Scroll-Sperre, die sich gegenseitig aufhebt.
      Menue-Drawer und Suchmodal setzten beide dieselbe Klasse auf <body>. Wer
      zuerst schloss, gab die Sperre frei - auch wenn das andere Overlay noch
      offen war. Hier zaehlt jetzt ein Zaehler mit.

   3) Seite scrollt unter dem offenen Drawer weiter.
      overflow:hidden auf <body> stoppt Touch-Scrolling unter iOS Safari nicht.
      Deshalb position:fixed plus Wiederherstellen der Scrollposition
      (siehe html.eg-locked in assets/ergovo-overlay.css).
   ========================================================================== */
(function () {
  'use strict';

  var count = 0;
  var savedY = 0;
  var root = document.documentElement;

  var Lock = {
    acquire: function () {
      if (count === 0) {
        savedY = window.pageYOffset || root.scrollTop || 0;
        // Scrollbarbreite ausgleichen, sonst springt das Layout auf dem Desktop.
        var gap = window.innerWidth - root.clientWidth;
        if (gap > 0) document.body.style.paddingRight = gap + 'px';
        document.body.style.top = -savedY + 'px';
        root.classList.add('eg-locked');
      }
      count++;
    },

    release: function () {
      if (count === 0) return;
      count--;
      if (count === 0) this._unlock();
    },

    // Notausstieg, falls ein Overlay seinen release() verpasst hat.
    reset: function () {
      if (count === 0) return;
      count = 0;
      this._unlock();
    },

    _unlock: function () {
      root.classList.remove('eg-locked');
      document.body.style.top = '';
      document.body.style.paddingRight = '';
      window.scrollTo(0, savedY);
    }
  };

  window.ErgovoLock = Lock;

  /* ------------------------------------------------------------------------
     Ein Overlay an den Zaehler haengen. Beobachtet wird die Klasse, die das
     Theme ohnehin schon setzt - so bleibt die bestehende Oeffnen-/Schliessen-
     Logik unangetastet.
     ------------------------------------------------------------------------ */
  function bindOverlay(el, openClass, onOpen) {
    if (!el) return;

    var wasOpen = el.classList.contains(openClass);
    if (wasOpen) Lock.acquire();

    new MutationObserver(function () {
      var isOpen = el.classList.contains(openClass);
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      if (isOpen) {
        Lock.acquire();
        if (onOpen) onOpen(el);
      } else {
        Lock.release();
      }
    }).observe(el, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    // --- Mobiler Menue-Drawer -------------------------------------------
    document.querySelectorAll('[data-kk-drawer]').forEach(function (drawer) {
      var panel = drawer.querySelector('[data-kk-drawer-panel]');

      // Fehler 1: Reste der Wischgeste entfernen, bevor der Drawer sichtbar
      // wird. Ohne das oeffnet er nach einem Swipe-Close seitlich versetzt.
      function clearSwipeRest() {
        if (!panel) return;
        panel.style.transform = '';
        panel.style.transition = '';
      }

      clearSwipeRest();
      bindOverlay(drawer, 'is-open', clearSwipeRest);

      // Zweite Absicherung: Auch direkt nach dem Loslassen aufraeumen, falls
      // die Geste ohne Schliessen endet oder vom Browser abgebrochen wird.
      if (panel) {
        ['touchend', 'touchcancel'].forEach(function (evt) {
          panel.addEventListener(evt, function () {
            setTimeout(function () {
              if (!drawer.classList.contains('is-open')) clearSwipeRest();
            }, 500);
          }, { passive: true });
        });
      }
    });

    // --- Suchmodal ------------------------------------------------------
    document.querySelectorAll('[data-kk-search]').forEach(function (modal) {
      bindOverlay(modal, 'is-open');
    });

    // --- Warenkorb-Drawer ------------------------------------------------
    document.querySelectorAll('cart-drawer').forEach(function (cart) {
      bindOverlay(cart, 'active');
    });
  }

  // Sicherheitsnetz: Nach einem Seitenwechsel (auch aus dem Back-Forward-Cache)
  // darf keine Sperre zurueckbleiben.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) Lock.reset();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
